import {
  required,
  minLength,
  email as emailValidator
} from 'vuelidate/lib/validators'

const PASSWORD_MIN_LENGTH = 6

export const username = {
  required
}

export const password = {
  required,
  minLength: minLength(PASSWORD_MIN_LENGTH)
}

export const email = {
  required,
  email: emailValidator
}
